import { render, staticRenderFns } from "./TestbankExamCopy.vue?vue&type=template&id=b7803c36&scoped=true&"
import script from "./TestbankExamCopy.vue?vue&type=script&lang=js&"
export * from "./TestbankExamCopy.vue?vue&type=script&lang=js&"
import style0 from "./TestbankExamCopy.vue?vue&type=style&index=0&id=b7803c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7803c36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7803c36')) {
      api.createRecord('b7803c36', component.options)
    } else {
      api.reload('b7803c36', component.options)
    }
    module.hot.accept("./TestbankExamCopy.vue?vue&type=template&id=b7803c36&scoped=true&", function () {
      api.rerender('b7803c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Exam/TestbankExamCopy.vue"
export default component.exports